import { render, staticRenderFns } from "./company_crts.vue?vue&type=template&id=1923f936&"
import script from "./company_crts.vue?vue&type=script&lang=js&"
export * from "./company_crts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports